import React, { useState, useEffect } from 'react';

import {
    listarCds,
    ListarCdsPorFiltro,
    gerarExelCds
} from '../../../../../services/http/buyerService'
import { trackPromise } from 'react-promise-tracker';
import { saveAs } from 'file-saver';
import { useSnackBar } from '../../../../../hooks/snackBar';

import ListCd from '../ListCd';

const CdBuyer = ({ chamarForm, idEmpresa }) => {
    const { addSnackBar } = useSnackBar();

    const [busca, setBusca] = useState('');
    const [listaCdsBuyer, setCdsBuyer] = useState(
        {
            numeroPagina: 0,
            totalPaginas: 0,
            lista: [],
            tamanhoPagina: 0,
            hasPreviousPage: false,
            hasNextPage: false
        });

        const CarregarListaBuyers = (pagina) => {
            trackPromise(
                listarCds(idEmpresa, pagina)
                    .then(res => {
                        console.log(res.data);
                        if (res.data) {
                            setCdsBuyer(res.data);
                        }
                    })
            ).catch(error => {
                console.log('Erro ao carregar lista de CDs');
            })
        }
    
        const CarregarListaBuyersComFiltro = (filtro, pagina) => {
            trackPromise(
                ListarCdsPorFiltro(idEmpresa, filtro, pagina)
                    .then(res => {
                        if (res.data) {
                            setCdsBuyer(res.data);
                        } else {
                            addSnackBar({ message: 'Não foi possível carregar CDs', info: 'error', open: true });
                        }
                    })
            ).catch(error => {
                addSnackBar({ message: 'Erro ano tentar carregar CDs', info: 'error', open: true });
            })
        }
    
        const buscar = (filtro) => {
            setBusca(filtro);
        }

        const extrairBase = () => {
            trackPromise(
                gerarExelCds(idEmpresa)
                    .then(res => {
                        console.log(res);
                        if (res.data) {
                            saveAs(res.data, "cadastros.xlsx")
    
                        } else {
                            addSnackBar({ message: 'Não foi possível extrair a base com CDs', info: 'warning', open: true });
                        }
                    })
            ).catch(error => {
                console.log(error);
                addSnackBar({ message: 'Erro ano extrair a base com CDs', info: 'error', open: true });
            })
        }
    
        const mudarPaginaBuyer = (page) => {
            busca != "" ? CarregarListaBuyersComFiltro(busca, page) : CarregarListaBuyers(page);
        }
    
        useEffect(() => {
            if (busca != "") {
                const delayDebounceFn = setTimeout(() => {
                    CarregarListaBuyersComFiltro(busca, 1);
                }, 2000)
    
                return () => clearTimeout(delayDebounceFn)
            } else {
                CarregarListaBuyers(1);
            }
    
        }, [busca]);

    return (
        <div>
            <ListCd
                data={listaCdsBuyer}
                mudarPagina={mudarPaginaBuyer}
                buscar={buscar}
                busca={busca}
                chamarForm={chamarForm}
                gerarExcel={extrairBase}
            />
        </div>
    )
}

export default CdBuyer;